import { statusTimelineStepLabelText, statusTimelineStepContentBase, statusTimelineStepLayout, statusTimelineConnectorLine } from '../utils/mixins';

export const getStepperOverrides = (theme) => ({
    MuiStep: {
        styleOverrides: {
          root: ({ theme }) => ({
            ".MuiStepper-root[data-status-timeline] &": statusTimelineStepLayout(theme),
          }),
        },
      },
    MuiStepLabel: {
        styleOverrides: {
          root: {
            ".MuiStepper-root[data-status-timeline] &": {
              padding: 0,
              alignItems: "center",
            },
          },
          label: ({ theme }) => ({
            ".MuiStepper-root[data-status-timeline] & .MuiTypography-root": statusTimelineStepLabelText(theme),
          }),
          iconContainer: ({ theme }) => ({
            ".MuiStepper-root[data-status-timeline] &": {
              paddingRight: theme.spacing(theme.palette.statusTimeline.stepLabel.iconGap),
            },
          }),
        },
      },
    MuiStepContent: {
        styleOverrides: {
          root: ({ theme }) => ({
            '&[data-connector-variant="pending"]': statusTimelineConnectorLine(theme, "pending"),
            '&[data-connector-variant="success"]': statusTimelineConnectorLine(theme, "success"),
            '&[data-connector-variant="terminal"]': statusTimelineStepContentBase(theme),
          }),
        },
      },
});
